import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { record_type, obj_type, class_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class EnsureSourcesArgs extends Record {
    constructor(studyId, imageLoader, wallCenterline, lumenCenterline, wallMaskFiles, lumenMaskFiles) {
        super();
        this.studyId = studyId;
        this.imageLoader = imageLoader;
        this.wallCenterline = wallCenterline;
        this.lumenCenterline = lumenCenterline;
        this.wallMaskFiles = wallMaskFiles;
        this.lumenMaskFiles = lumenMaskFiles;
    }
}

export function EnsureSourcesArgs_$reflection() {
    return record_type("Client.Visualization.DiameterMeasurement.EnsureSourcesArgs", [], EnsureSourcesArgs, () => [["studyId", class_type("System.Guid")], ["imageLoader", obj_type], ["wallCenterline", obj_type], ["lumenCenterline", obj_type], ["wallMaskFiles", obj_type], ["lumenMaskFiles", obj_type]]);
}

